import Vue from "vue";
import moment from "moment";
import { EventBus } from "@/services/EventBus";

export default class {
  constructor() {
    this.v = "v1";
  }

  get(url, options = {}) {
    return Vue.http.get("/api/" + this.v + "/" + url, options).then(
      r => {
        return r.body.data;
      },
      r => {
        if (r.status !== 400) {
          EventBus.$emit("error", {
            message: "global.temporarilyUnavailable",
            code: r.status
          });
        }

        return Promise.reject(r);
      }
    );
  }

  getImage(url, options = {}) {
    return Vue.http.get(url, options).then(r => {
      let urlCreator = window.URL || window.webkitURL;

      return urlCreator.createObjectURL(r.bodyBlob);
    });
  }

  getCams() {
    return this.get("cameras");
  }

  getCam(id) {
    return this.get("cameras/" + id);
  }

  getCamImage(id) {
    return this.getImage(
      "/api/v2/cameras/" + encodeURIComponent(id) + "/image",
      {
        responseType: "blob"
      }
    );
  }

  getMapImage(mapId, planId) {
    return this.getImage("/api/v1/maps/" + mapId + "/image/" + planId, {
      responseType: "blob"
    });
  }

  getMaps() {
    return this.get("maps");
  }

  getMap(mapGroupId) {
    return this.get(`maps/${mapGroupId}`);
  }

  getAlarms(cams, params = {}) {
    return new Promise((resolve, reject) => {
      let requests = [];
      let requestDateFormat = "YYYYMMDDTHHmmss";
      let result = [];

      params.start_time = moment(params.start_time).format(requestDateFormat);
      params.stop_time = moment(params.stop_time).format(requestDateFormat);

      cams.forEach(cam => {
        requests.push(
          this.get("cameras/" + encodeURIComponent(cam.id) + "/protocol", {
            params: params
          })
        );
      });

      Promise.all(requests).then(
        r => {
          r.forEach((data, i) => {
            let cam = cams[i];

            data.events.forEach(event => {
              result.push({
                camId: cam.id,
                name: cam.name,
                timestamp: moment(event.time, "DD-MM-YY HH:mm:ss").unix(),
                ...event
              });
            });
          });

          resolve(result);
        },
        e => reject(e)
      );
    });
  }

  getPage(name) {
    return Vue.http.get("/static/pages/" + name + ".html").then(r => {
      return r.body;
    });
  }

  getAcsObject(type, id) {
    return new Promise(resolve => {
      this.get(`acsconfig?type=${type}&ids=${id}`)
        .then(r => {
          resolve(r[0]);
        })
        .catch(e => {
          resolve(null);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js